<div [formGroup]="form">
    <div class="section-container" id="custos">
        <div class="section-title">
            <mat-icon>trending_up</mat-icon>
            <span>Histórico de Custos</span>
        </div>

        <div class="row mt-2">
            <div class="col-6 col-lg-3">
                <mat-form-field appearance="outline" class="w-100"
                    matTooltip="Custo médio do produto no estoque da empresa, atualizado pelas entradas de compra, início de estoque e ordem de produção.">
                    <mat-label>Custo médio atual</mat-label>
                    <input matInput readonly [value]="custoMedioAtual | abnt: 'preco'">
                </mat-form-field>
            </div>
        </div>

        <div formArrayName="custos">
            <div class="d-flex justify-content-between align-items-center mb-2 mt-2">
                <h4 class="subsection-title mb-0">Custos</h4>
                <button mat-button type="button" (click)="addCustoRow()">
                    <mat-icon>add</mat-icon> Informar novo custo
                </button>
            </div>

            @for (item of custos.controls; track item; let i = $index) {
            <div [formGroupName]="i">
                <div class="row margin-bottom-50">
                    <div class="col-10 col-md-11">
                        <div class="row">
                            <div class="col-6 col-lg-3">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Data Vigência</mat-label>
                                    <input matInput [matDatepicker]="pickerCusto" formControlName="dataVigencia"
                                        placeholder="DD/MM/AAAA" (input)="onDateInput($event)">
                                    <mat-datepicker-toggle matSuffix [for]="pickerCusto"></mat-datepicker-toggle>
                                    <mat-datepicker #pickerCusto></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="col-6 col-lg-3">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Impostos Recup.</mat-label>
                                    <input matInput formControlName="impostosRecuperaveis"
                                        [currencyMask]="defaultCurrencyMask">
                                </mat-form-field>
                            </div>

                            <!-- Linha 2: Preços + Delete -->
                            <div class="col-6 col-lg-3">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Preço Custo</mat-label>
                                    <input matInput formControlName="precoCusto" [currencyMask]="dynamicCurrencyMask">
                                </mat-form-field>
                            </div>

                            @if (item.get('idNFeEntrada')?.value) {
                            <div class="col-6 col-lg-3 d-flex flex-column justify-content-center">
                                <small class="d-block">Documento de origem</small>
                                <a [routerLink]="['/suprimentos/nota-fiscal-entrada/documento', item.get('idNFeEntrada')?.value]"
                                    [queryParams]="{ modo: 'visualizar' }">NF-e de entrada</a>
                            </div>
                            }
                        </div>
                    </div>
                    <div class="col-2 col-md-1 produto-grid-delete-col">
                        <button mat-icon-button class="produto-grid-delete-button" type="button"
                            (click)="removeCustoRow(i)" matTooltip="Remover">
                            <mat-icon class="material-symbols-outlined">delete</mat-icon>
                        </button>
                    </div>
                </div>
            </div>
            }

            @if (custos.length === 0) {
            <app-empty-state icon="trending_up" title="Nenhum custo cadastrado."
                subtitle="Registre os custos do produto ao longo do tempo para acompanhar sua evolução de preço e margem.">
            </app-empty-state>
            }
        </div>
    </div>
</div>